export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/brand-amex.96d942fb.svg","height":16,"width":26,"blurWidth":0,"blurHeight":0};